<button title="PreSave on Spotify" (click)="onClick()">
  <span class="bt-text">
    <i class="fab fa-spotify"></i>
    PRE-SAVE
  </span>
</button>
